import { createSelector } from 'reselect'

const userState = state => state.user
const loginState = state => state.login

export const adsenseUserState = createSelector(
  [userState, loginState],
  (user, login) => ({
    isLoading: user.loading || login.loading,
    isUserLoaded: user.loaded,
    hasUserError: Boolean(user.error),
    isLoggedIn: login.isLoggedIn,
    isPaidUser:
      (user.data && user.data.subscription && user.data.subscription.is_vip) ||
      false,
  })
)

export const isUserLoading = createSelector([userState], user => user.loading)

export const userData = createSelector([userState], user => user.data)

export const isPremiumUser = createSelector(
  [userData],
  data => (data && data.subscription && data.subscription.is_vip) || false
)

export const userPayments = createSelector(
  [userData],
  data => (data && data.payments) || []
)

export const combinedDetails = createSelector(
  [userData, loginState],
  (user, login) => ({
    ...user,
    lastLogin: login.lastLogin,
  })
)

export const userSettings = createSelector(
  [userData],
  data => (data && data.settings) || []
)
